import { easeOutCubic, useProgress } from './motion'

/** A number that counts up quickly from 0 to `value` when it first appears or changes. */
export default function CountUp({ value, duration = 650, decimals = 0 }: { value: number; duration?: number; decimals?: number }) {
  const progress = useProgress(duration, easeOutCubic, value)
  const factor = 10 ** decimals
  return <>{(Math.round(value * progress * factor) / factor).toLocaleString(undefined, { maximumFractionDigits: decimals })}</>
}
